import { useMemo } from 'react';

import { useBreakPoints } from 'core';
import { useNavigate } from 'react-router-dom';
import { useListSelectedCausesInfo } from 'store/Api';
import { AddACauseCard, AspectRatio, Carousel, CauseStoreCard, SimpleGrid, Skeleton } from 'ui';
import { IconChevronLeft, IconChevronRight } from 'ui/Icons';

import classes from './MyFavoriteCausesCarousel.module.css';

const MyFavoriteCausesCarousel = () => {
  const { data: userCauseSelections, isLoading: isLoadingUserCauseSelections } =
    useListSelectedCausesInfo();
  const navigate = useNavigate();
  const { isSmallScreen } = useBreakPoints();

  const isShowIndicators = useMemo(() => {
    if (!userCauseSelections?.length) return;
    return isSmallScreen && userCauseSelections.length >= 2;
  }, [isSmallScreen, userCauseSelections?.length]);

  const isShowControls = useMemo(() => {
    if (!userCauseSelections?.length) return;
    return !isSmallScreen && userCauseSelections.length >= 4;
  }, [isSmallScreen, userCauseSelections?.length]);

  if (isLoadingUserCauseSelections) {
    const skeletonCount = isSmallScreen === false ? 4 : 2;
    return (
      <SimpleGrid cols={{ base: 2, sm: 4 }}>
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <Skeleton key={index} visible={isLoadingUserCauseSelections}>
            <AspectRatio ratio={1 / 1.25}>
              <CauseStoreCard />
            </AspectRatio>
          </Skeleton>
        ))}
      </SimpleGrid>
    );
  }

  return !userCauseSelections?.length ? (
    <SimpleGrid cols={{ base: 2, sm: 4 }}>
      <AddACauseCard onClick={() => navigate('/causes')} isColumn />
      <AddACauseCard onClick={() => navigate('/causes')} isColumn />
    </SimpleGrid>
  ) : (
    <Carousel
      slideSize={{ base: '50%', sm: '25%' }}
      slideGap="sm"
      align="start"
      withControls={isShowControls}
      withIndicators={isShowIndicators}
      nextControlIcon={<IconChevronRight color="#666666" />}
      previousControlIcon={<IconChevronLeft color="#666666" />}
      classNames={classes}
    >
      {userCauseSelections?.map((cause) => (
        <Carousel.Slide key={cause.uuid}>
          <CauseStoreCard
            imgSrc={cause.logo?.url}
            title={cause.name}
            w="100%"
            onClick={() => navigate(`/causes/${cause.uuid}`)}
            titleLineClamp={2}
          />
        </Carousel.Slide>
      ))}

      <Carousel.Slide>
        <AddACauseCard onClick={() => navigate('/causes')} isColumn />
      </Carousel.Slide>
    </Carousel>
  );
};

export { MyFavoriteCausesCarousel };
